import { useState } from "react";
import ReactLoading from "react-loading"
type propsType = {
    disp: boolean;
}

const PositionLogLoading = (props: propsType) => {

    console.log("Props:" + props.disp)
    return (
        <div>
        { props.disp && <><ReactLoading
                type="spin"
                color="black"
                height="100px"
                width="100px"
                className="mx-auto" /><p className="text-center mt-3">PositionLogを生成中・・・</p></>

            
        }
        
         </div>
        
    )
   
}
export default PositionLogLoading